import { gql } from "@apollo/client";

const ADD_SUCCESSOR_TO_PRODUCT = gql`
  mutation AddSuccessorToProduct(
    $productId: ID!
    $successor: CreateSuccessorInput!
    $branding: String!
  ) {
    addSuccessorToProduct(productId: $productId, successor: $successor, branding: $branding) {
      product {
        ... on DafProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
      }
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
    }
  }
`;

const UPDATE_SUCCESSOR = gql`
  mutation UpdateSuccessor(
    $args: UpdateSuccessorInput!
    $productId: ID!
    $successorIndex: Int!
    $branding: String!
  ) {
    updateSuccessor(
      args: $args
      productId: $productId
      successorIndex: $successorIndex
      branding: $branding
    ) {
      product {
        ... on DafProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
        ... on ClatProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
        ... on BrandingProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
      }
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
    }
  }
`;

const REMOVE_SUCCESSOR_FROM_PRODUCT = gql`
  mutation RemoveSuccessorFromProduct($productId: ID!, $successorIndex: Int!, $branding: String!) {
    removeSuccessorFromProduct(
      productId: $productId
      successorIndex: $successorIndex
      branding: $branding
    ) {
      product {
        ... on DafProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
        ... on ClatProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
        ... on BrandingProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
      }
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
    }
  }
`;

const UPDATE_SUCCESSOR_PERCENTAGES = gql`
  mutation UpdateSuccessorPercentages(
    $productId: ID!
    $branding: String!
    $successorPercentages: [SuccessorPercentagesInput]!
  ) {
    updateSuccessorPercentages(
      productId: $productId
      branding: $branding
      successorPercentages: $successorPercentages
    ) {
      product {
        ... on DafProduct {
          _id
          successors {
            address1
            address2
            city
            country
            createdAt
            ein
            email
            firstName
            lastName
            organizationName
            organizationNotes
            percentOfDaf
            phone
            relationship
            state
            status
            type
            updatedAt
            zip
          }
        }
      }
      mailChimpResponse {
        _id
        email
        queued_reason
        reject_reason
        status
      }
    }
  }
`;

export {
  ADD_SUCCESSOR_TO_PRODUCT,
  UPDATE_SUCCESSOR,
  REMOVE_SUCCESSOR_FROM_PRODUCT,
  UPDATE_SUCCESSOR_PERCENTAGES,
};
